import { Icon } from '@neshane/blueberry';

import styles from './ReleaseDetailsLink.module.css';

export const ReleaseDetailsLink = ({ href }) => {
  if (!href) {
    return null;
  }

  return (
    <li>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href={href} className={styles.releaseNavigationItem}>
        <span className="whitespace-nowrap">
          <Icon name="megaphone" size="m" className="ml-12 shrink-0" aria-hidden="true" />
          نسخه‌های جدید
        </span>
        <div className={`flex flex-col gap-12 ${styles.releaseContent}`}>
          <span className="text-secondary-bg-primary">
            تازه‌ترین امکانات و بهبودهای سامانه را ببینید
          </span>
          <span className="text-info-default">
            مشاهده
            <Icon name="arrow-left" size="m" className="ml-4 align-middle" aria-hidden="true" />
          </span>
        </div>
      </a>
    </li>
  );
};